/**
 * Agent Reporting — layout wrapper
 *
 * Route: /admin/reporting/agents (layout)
 *
 * Renders <Outlet /> so child routes (index = list, $id = detail) display.
 */

import { Outlet } from '@tanstack/react-router'

export const Route = createFileRoute({
  component: AgentsLayout,
})

function AgentsLayout() {
  return <Outlet />
}
